import MapionDatumUtil from '../../config/adapters';
import LineColorDictionary from '../../services/lineColorDictionary';

const TransitResult = (
  { naviSearch, setNaviSearch, map, naviToggle, naviStart,naviEnd,
    setIsSmp, naviFromToggle, setNaviURLParam, resultError, setResultError, isTablet}
) => {
  const REACT_APP_API_TRANSFER_ROUTE_URL = process.env.REACT_APP_API_TRANSFER_ROUTE_URL
  const MILLISECONDS_PER_DEGREE = 60 * 60 * 1000;  // minutes * seconds * milliseconds
  const ONE_OVER_MILLISECONDS_PER_DEGREE = 1 / MILLISECONDS_PER_DEGREE;
  const LINE_WIDTH = 8
  const LINE_OPACITY = 0.80
  const LINE_COLOR_DEPARTURE = '#00da0f'
  const LINE_COLOR_STATION_LINK = '#0065ff'
  const TYPE = {
    WALK: 'WALK',
    TRAIN: 'TRAIN',
    SHINKANSEN: 'SHIN',
    PLANE: 'PLANE',
    BUS: 'BUS',
    CAR: 'CAR'
  }

  const SCROLL_DELAY_TIME = 300; // SP結果のスクロールで結果の開閉にアニメーションがあるので、それを考慮してスクロールを遅らせる値

  const lineColorDict = new LineColorDictionary();

  const convertPathToFromToPoint = (path) => {
    const paths = path.split(",");
    const [fromLon, fromLat] = paths;
    const [toLon, toLat] = paths.slice(-2);
    const convertPoint = (lon, lat) => {
      return {
        lon: lon * ONE_OVER_MILLISECONDS_PER_DEGREE || null,
        lat: lat * ONE_OVER_MILLISECONDS_PER_DEGREE || null,
      };
    };
    return {
      from: convertPoint(fromLon, fromLat),
      to: convertPoint(toLon, toLat),
    }
  }
  
  // ハンドラ関連
  // 左リストのポイントをクリックで中心に移動する
  const moveCenter = (e, lat, lon) => {
    let {currentTarget} = e;
    const $ = window.$;
    e.preventDefault();
    map.flyTo({center: [lon, lat]})

    if(isTablet){
      naviFromToggle(false, true, true); // SPの場合はフォーム閉じて地図表示しておく
      setTimeout(()=>{
        // SPの場合は選択した要素までスクロールしておく
        let offset = $(currentTarget).offset().top - $(".navi-result-component").offset().top;
        let scrollAmount = $(".navi-result-component").scrollTop();
        $(".navi-result-component").scrollTop(scrollAmount + offset);
      }, SCROLL_DELAY_TIME);
    }
  }

  const fitPointToPoint = (e) => {
    let {currentTarget} = e;
    const $ = window.$;
    let {lat: firstLat, lon: firstLon} = $(currentTarget).prev().data();
    let {lat: lastLat, lon: lastLon} = $(currentTarget).next().data();

    // 必ず min=西南 max=北東 にする ※これやらないとfitboundsでバグる
    let minLat = firstLat < lastLat? firstLat: lastLat;
    let minLon = firstLon < lastLon? firstLon: lastLon;
    let maxLat = firstLat > lastLat? firstLat: lastLat;
    let maxLon = firstLon > lastLon? firstLon: lastLon;

    let padding =  {top: 100, left: 500, bottom: 100, right:40};
    if(isTablet){
      padding=  {top: 160, left: 30, bottom: 260, right:80}; // SPの場合は範囲が狭いので余白を変える※上下左右の対象同士の値が画面の範囲を超えると全くうごかなくなるので
      naviFromToggle(false, true, true); // SPの場合は地図表示しておく
      setTimeout(()=>{
        // SPの場合は選択した要素までスクロールしておく
        let offset = $(currentTarget).offset().top - $(".navi-result-component").offset().top;
        let scrollAmount = $(".navi-result-component").scrollTop();
        $(".navi-result-component").scrollTop(scrollAmount + offset);
      }, SCROLL_DELAY_TIME);
    }

    map.fitBounds([[minLon, minLat], [maxLon, maxLat]],{
      padding
    });

  }

  // タブの切替のハンドラ
  const changeRouteTabs = (e)=>{
    let {currentTarget} = e;
    let $ = window.$;
    e.preventDefault();
    let {id} = $(currentTarget).data();
    
    // currentRouteIdx = id;
    if(id==="list"){
      setNaviSearch({ ...naviSearch,  currentRouteIdx: id});      
    } else {
      // 地図上のルートを切り替えるためtransitResultを更新する
      let {transitResultData} = naviSearch;
      let geojson = makeGeoJSON(transitResultData, id);
      setNaviSearch({ ...naviSearch, transitResult:geojson, currentRouteIdx: id, resultRendered: false});
    }
  }

  // 分を時・分に変換する
  const minutesToHrsMns = (minutes) => {
    return {
      hrs: Math.floor(minutes / 60),
      mns: minutes % 60
    }
  }

  /*
  * @param hour Number 0〜23
  * @param min Number 0〜59
  * @param duration Number 分間
  * @returns {hour, min}
  */
  const adjustHourMin = (hour, min, duration) => {
    min += duration

    // 59分を超えると時に持ち越す
    if(min >= 60 || min < 0){
      // 日付は関係無いので、時は剰余だけでOK
      hour = (hour + (Math.floor(min / 60))) % 24
      if(hour < 0) { // 0時以前の場合
        hour = 24 - Math.abs(hour);
      }
      if(min >= 60){
        min %= 60;
      } else{
        min = 60 - (Math.abs(min) % 60)
      }
    }
    return {
      hour,
      min
    }
  }

  // データ整形で使用。主に乗り換え回数のカウントを行っている
  const extractLines = (lines) => {
    let fGroupId = null;
    let fFirstInGroup = null;
    let fare = null;
    let tGroupId = null;
    /* eslint-disable no-unused-vars */
    let tFirstInGroup = null;
    /* eslint-enable no-unused-vars */ // 下部で使ってるのに警告が出るので一旦eslintを切る
    let transferCount = 0;
    lines.forEach((line)=> {
      // FareGroupAlignerの処理
      if(fGroupId === null || fGroupId !== line.fareGroupId){
        // 保持
        fGroupId = line.fareGroupId;
        fFirstInGroup = line;
        fare = line.fare;
      } else {
        // 最初の要素の料金情報を更新する
        // 2つ目以降、料金を更新する
        fare = line.fare;
        fFirstInGroup.fare = fare;

        // この要素の料金情報が不要なので、空文字列化
        line.fare = ''
      }

      // TransferCounterAndChokutsuuIdentifierの処理 ※乗り換え回数の積算
      if(!tGroupId){ // ひとまず最初のグループを保持
        tGroupId = line.tGroupId;
        tFirstInGroup = line;

        // 徒歩の場合はマイナス
        if(line.railKind === '徒歩' || line.lineName === '徒歩'){
          transferCount--;
        }
      } else if(tGroupId !== line.tGroupId){ // 保持したグループと違う場合
        tGroupId = line.tGroupId;
        tFirstInGroup = line;

        // グループが変わったので、
        // カウントをインクリメントする ※乗り換え回数を増やす
        // 但し、徒歩の場合は乗換としない
        if(!(line.railKind === '徒歩' || line.lineName === '徒歩')){
          transferCount++;
        }
      } else {
        // グループが同じなので直通であり、
        // 乗換回数が変わらない
        line.isChokutsuu = true;
      }
    });
    lines.transferCount = transferCount; // 乗り換え回数を反映
    return lines;
  }

  // lineNameに対してそれぞれのタイプを割り当てる
  const extractType = (line) => {
    if(line.lineName === '徒歩'){
      return TYPE.WALK;
    }else if (line.railKind === '私鉄'){
      return TYPE.TRAIN;
    }else if (line.railKind === 'JR'){
      if(line.railKindNote === '新幹線'){
        return TYPE.SHINKANSEN;
      }else{
        return TYPE.TRAIN;
      }
    }else if (line.railKind === '飛行機'){
      return TYPE.PLANE;
    }else if (line.railKind === 'バス'){
      return TYPE.BUS;
    }else{
      return null; // 'no type for'
    }
  }

  // 対象が配列か否かの判定
  const isArray = (target)=> toString.call(target) === '[object Array]';

  // 発-電車、電車-着の間のルートが徒歩か車か判定する
  const _routeTypeToType = (routeType) => {
    if(routeType === "d"){
      return TYPE.CAR;
    } else if (routeType === "w") {
      return TYPE.WALK;
    }
    return null; // 'unknown route type'
  }

  // 徒歩ルートのみの場合の発・着データを生成する
  const processWalkRoute = (departureAddress, arrivalAddress, walkRoute) => {
    let departure ={
      address: departureAddress,
      coordinates: {
        lat: walkRoute.departure.nl,
        lon: walkRoute.departure.el
      },
      time: {
        hour: 0,
        min: 0
      }
    };
    let arrival = {
      address: arrivalAddress,
      coordinates: {
        lat: walkRoute.arrival.nl,
        lon: walkRoute.arrival.el
      },
      time: {
        hour: 0,
        min: 0
      }
    }
    return {
      departure: departure,
      arrival: arrival,
      links: walkRoute.links.link,
      distance: walkRoute.distance,
      duration: minutesToHrsMns(+walkRoute.necessaryMin)
    }
  }

  // 1〜3経路で早・安・楽の比較して、各経路の一番の早・安・楽を設定する
  const processRouteList = (departureAddress, arrivalAddress, routeList, maxRouteCount = 3) => {
    let {transitMode, time} = naviSearch.transit;
    let requestedTime = null;
    if(transitMode === 0 || transitMode === 2){ // 出発、始発の場合
      // settings.mode, settings.hour, settings.min
      let [h1, h2, m1, m2] = time;
      requestedTime = {
        hour: Number(h1 + h2),
        min : Number(m1 + m2)
      };
    }

    let routeCount = Math.min(maxRouteCount, routeList.length);
    let routes = routeList.slice(0, routeCount).map((route)=>{
      return processRoute(departureAddress, arrivalAddress, route);
    });

    // 一度、早安楽の判別を行う
    let fastestTime = Number.POSITIVE_INFINITY;
    let fastestIdx = [];

    let earliestTime = Number.POSITIVE_INFINITY;
    let earliestIdx = [];

    let lowestFare = Number.POSITIVE_INFINITY;
    let cheapestIdx = [];

    let leastTransfers = Number.POSITIVE_INFINITY;
    let easiestIdx = [];
    // fastCheapEasyTrackerのtrack処理 start
    routes.forEach((route, idx)=>{
      // 早
      // 出発、もしくは、始発の場合は「一番早く到着する経路」
      // 到着、もしくは、終電の場合は「所要時間が一番短い経路」Redmin #17626
      let totalTime = 0;
      if(requestedTime){
        // [方針] リクエスト時の出発時刻を基準に到着までの経過時間を加算して到着時刻を出す

        // 基準時間(リクエスト時の出発時刻)
        let standardMin = (requestedTime.hour * 60) + requestedTime.min

        // ルートの経過時間
        let durationMin = (route.duration.hrs * 60) + route.duration.mns

        // ルートの出発時刻
        let departureTime = route.departure.time;
        let departureMin = (departureTime.hour * 60) + departureTime.min

        // 基準時間から出発時刻までの経過時刻を求める
        let fromStandardTimeToDepartureTime = standardMin > departureMin
          // 基準時間よりも出発時間が下回る場合は日付を跨いでいると見なす
          ?  ((24* 60) - standardMin) + departureMin // (基準時刻から24:00までの時間) + (0:00から出発時刻までの時間)
          : departureMin - standardMin;
        totalTime = fromStandardTimeToDepartureTime + durationMin; // (基準時間から出発時刻までの経過時間) + (ルートの経過時間)
      } else {
        totalTime = (route.duration.hrs * 60) + route.duration.mns;
      }

      if(totalTime < fastestTime) {
        fastestTime = totalTime
        fastestIdx = [idx]
      }else if(totalTime === fastestTime){
        fastestIdx.push(idx);
      }

      // 早 経過時刻が一番短い
      totalTime = (route.duration.hrs * 60) + route.duration.mns;
      if(totalTime < earliestTime){
        earliestTime = totalTime;
        earliestIdx = [idx];
      }else if(totalTime === earliestTime){
        earliestIdx.push(idx);
      }

      // 安
      let fare = +route.fare;
      if(fare < lowestFare){
        lowestFare = fare;
        cheapestIdx = [idx];
      } else if(fare === lowestFare){
        cheapestIdx.push(idx);
      }

      // 楽
      let transfers = route.transfers;
      if(transfers < leastTransfers){
        leastTransfers = transfers;
        easiestIdx = [idx];
      } else if(transfers === leastTransfers){
        easiestIdx.push(idx);
      }
    });
    // fastCheapEasyTrackerのtrack処理 end

    //出発、始発の場合は、到着時刻が同じで、他と比べて経過時間が短いルートを優先する
    if(requestedTime){
      // fastCheapEasyTracker.changeFastAndEarlyTrack()の処理
      let fastAndEarlyIdx = fastestIdx.filter(item => earliestIdx.includes(item)); // intersectionする(積集合)
      if(fastAndEarlyIdx.length !== 0){
        fastestIdx = fastAndEarlyIdx;
      }
    }
    // それから再びループして適用
    // NOTE `FastCheapEasyTracker`内で`idx`の代わりに参照を持ってしまえば、
    //      このループが要らなくなるが、所詮、要素が3つしか無い為、
    //      然程の負荷でもなかろう。
    // ※各ルートごとで早・安・楽が含まれてるかチェックして設定する
    routes.forEach((route, idx)=>{
      route.isFast =  fastestIdx.includes(idx); 
      route.isCheap = cheapestIdx.includes(idx);
      route.isEasy = easiestIdx.includes(idx);
    });
    return routes;
  }

  // routeList:[route, ...] のrouteのデータを整形する
  const processRoute = (departureAddress, arrivalAddress, route) => {
    if(!route) return null; //データが存在しない場合はひとまずnullを返す

    let lines = route.lineList.line;

    // 要素が一つだけある場合に配列化する必要がある
    if(lines && !isArray(lines)){
      lines = [lines]
    }

    let {departureSpace, arrivalSpace} = route.routeStation;
    var {hour: fromHour, min: fromMin} = lines[0].stationFrom.time;

    let ds = departureSpace;
    let departure = {
      hasRoute: !!ds,
      address: departureAddress,
      coordinates: ds && ds.departure? ds.departure: null,
      distance: ds&& ds.distance? ds.distance: null,
      duration: ds&&ds.necessaryMin?  ds.necessaryMin: null,
      links: ds&&ds.links? ds.links.link: null,
      time: adjustHourMin( +fromHour, +fromMin, -(+(ds&&ds.necessaryMin?ds.necessaryMin: 0)))
    }
    if(departure.hasRoute) departure.routeType = _routeTypeToType(departureSpace.routeType);

    var {hour: toHour, min: toMin} = lines[lines.length - 1].stationTo.time;
    let as = arrivalSpace;
    let arrival = {
      hasRoute: !!as,
      address: arrivalAddress,
      coordinates: as && as.arrival? as.arrival : null,
      distance: as && as.distance? as.distance: null,
      duration: as && as.necessaryMin? as.necessaryMin: null,
      links: as && as.links && as.links.link? as.links.link: null,
      time: adjustHourMin( +toHour, +toMin, +(as && as.necessaryMin? as.necessaryMin:0))
    }

    if(arrival.hasRoute) arrival.routeType = _routeTypeToType(as.routeType); // ポイント作成時のアイコン判定で使う

    let {time, fare} = route;

    return {
      duration: minutesToHrsMns(time.total),
      fare: fare,
      lines: extractLines(lines),
      transfers: route.transferNumberOfTimes,
      departure: departure,
      arrival: arrival
    }
  }

  // path: [x1,y1,x2,y2...]のデータを10進数の緯度経度に変換し、日本測地系→世界測地系変換をする
  const extractPolyline = (links) => {
    if(!links) return [];
    let linkData = links.flatMap(({path})=>{
      let lines = path.split(",")
        .map(coord=> parseFloat(coord) * ONE_OVER_MILLISECONDS_PER_DEGREE)  // 60進数→10進数変換
        .reduce((acc, coord, index) => { // "x,y,x,y,x,y" のデータをlat,lonに切り分ける
          if (index % 2 === 0) {
            acc.push([coord]);
          } else {
            acc[acc.length - 1].push(coord); // 最後の配列に追加
          }
          return acc;
        }, []).map(([lon, lat]) => ({lat, lon}))
        .map(({lat, lon}) => { // 東京測地系→WGS84変換
          let {y, x} = MapionDatumUtil.tky.wgs({y: lat, x: lon});
          return [x, y];
        })
      return  lines; 
    });
    return linkData;
  }

  // 地図描画用のgeoJSONのポリラインのFetureを作成する
  const makeGeojsonFeture = (type, links) => {
    return {
      type: "Feature",
      properties: {
        "stroke": type === "walk"?  LINE_COLOR_DEPARTURE: LINE_COLOR_STATION_LINK,
        "stroke-width": LINE_WIDTH,
        "stroke-opacity": LINE_OPACITY
      },
      geometry: {
        type: "LineString",
        coordinates: links
      }
    }
  }

  const _toThousandSeparator = (num) =>{
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }

  const _pad = (i) => {
    return i < 10 ? `0${i}`: `${i}`;
  }

  // 地図描画用のGeoJSONを生成する
  const makeGeoJSON = (processedData, currentRouteIdx)=>{
    let data = processedData;
    let route = currentRouteIdx === "walk"
      ? data.walkRoute
      : data.routeList[currentRouteIdx];
    let polyLineFeatures = [];
    let pointFeatures = [];
    
    if(route){
      // ポリラインの描画用のGEOJSONを作成する
      if(isArray(route.links)){ // route.linksがある場合は歩き
        let links = extractPolyline(route.links)
        polyLineFeatures.push(makeGeojsonFeture("walk", links));
      } else {
        // 出発地→出発駅
        let departureLinks = extractPolyline(route.departure.links);
        if(departureLinks){
          polyLineFeatures.push(makeGeojsonFeture("walk", departureLinks));
        }

        // 乗換ルートの線を引く
        let {lines} = route;
        if(isArray(lines)){
          lines.forEach((line, idx)=>{
            let segment = extractPolyline([line.pathList]);
            let type =  extractType(line) === TYPE.WALK? "walk": "station";
            polyLineFeatures.push(makeGeojsonFeture(type, segment));

            // 各ポイントのアイコンを作る
            var {from} = convertPathToFromToPoint(line.pathList.path);
            if(from){
              let {lon, lat} = from;
              let {y, x} = MapionDatumUtil.tky.wgs({y: lat, x: lon});
              let type = extractType(line).toLowerCase();
              pointFeatures.push({
                "type": "Feature",
                "properties": {
                  imgSrc: `https://www.mapion.co.jp/f/mapion_map/img/navi/navi_icon_${type}.png`,
                  iconSize: [28, 28]
                },
                "geometry": {
                  "coordinates": [
                    x,
                    y
                  ],
                  "type": "Point"
                }
              });

              // 最後の要素の場合は到着点の要素のアイコンを置く
              if(idx === (lines.length - 1)){
                if(route.arrival.hasRoute){
                  let [filstLink] = route.arrival.links;
                  let {from: firstLinkFrom} = convertPathToFromToPoint(filstLink.path);
                  let {lon: firstLinkLon, lat: firstLinkLat} = firstLinkFrom;
                  let {y: firstLinkY, x: firstLinkX} = MapionDatumUtil.tky.wgs({y: firstLinkLat, x: firstLinkLon});
                  type = route.arrival.routeType.toLowerCase();
                  if(firstLinkFrom){
                    pointFeatures.push({
                      "type": "Feature",
                      "properties": {
                        imgSrc: `https://www.mapion.co.jp/f/mapion_map/img/navi/navi_icon_${type}.png`,
                        iconSize: [28, 28]
                      },
                      "geometry": {
                        "coordinates": [
                          firstLinkX,
                          firstLinkY
                        ],
                        "type": "Point"
                      }
                    });
                  }
                }
              }
            }
          });
        }

          // 到着駅→目的地
        let arrivalLinks = extractPolyline(route.arrival.links);
        if(arrivalLinks){
          polyLineFeatures.push(makeGeojsonFeture("walk", arrivalLinks));
        }
      }
    } else {
      // <div>ルート検索ができませんでした。<br />検索条件を変更して再度お試しください。</div>
    }

    let geojson = { // geojsonと言いながらfeaturesで区別する ※maplibreのpolylineとpointは区別してレンダリングしかできないため
      polyLineFeatures,
      pointFeatures
    };
    return geojson;
  }

  // 検索の実施
  const execSearch = () => {
    // ルート検索実行処理
    // パラメータを作る
    let {transitMode} = naviSearch.transit;
    let params = Object.keys(naviSearch.transit).map(key => {
      if(key === "transitMode") return "";

      // 出発、到着、始発、終電 の処理
      if(key === "mode" && (transitMode === 0 || transitMode === 2)){ // 出発、始発はdepartureモード
        return "mode=departure"
      }else if(key === "mode" && (transitMode === 1 || transitMode === 3)){ // 到着、終電はarrivalモード
        return "mode=arrival"
      }

      // 始発の場合は当日の午前2時に時間を設定する
      if(key === "time" && transitMode === 2){
        return "time=0200";
      }else if(key === "time" && transitMode === 3){ // 終電の場合の時間は次の日の午前4時に設定する
        return "time=0400";
      }

      // 終電の場合の日にちは次の日の午前4時に設定する
      if(key === "date" && transitMode === 3){
        let [y1,y2,y3,y4,m1,m2,d1,d2] = String(naviSearch.transit[key]); // yyyymmddの文字列を抽出
        let nextDay = Number(d1 + d2) + 1;
        let month = Number(m1 + m2) - 1;
        let d = new Date( `${y1}${y2}${y3}${y4}`, month, nextDay);
        let yyyy = d.getFullYear();
        let mm = _pad(d.getMonth() + 1);
        let dd = _pad(d.getDate());
        return `date=${yyyy}${mm}${dd}`
      }

      return `${encodeURIComponent(key)}=${encodeURIComponent(naviSearch.transit[key])}`;
    });
    var start = naviStart;
    let {x: startX, y: startY} = MapionDatumUtil.wgs.tky({y: start.lat, x: start.lon});
    params.push(`origin=${startY}${encodeURIComponent(",")}${startX}`);
    var end = naviEnd;
    let {x: endX, y: endY} = MapionDatumUtil.wgs.tky({y: end.lat, x: end.lon});
    params.push(`destination=${endY}${encodeURIComponent(",")}${endX}`);

    let url = `${REACT_APP_API_TRANSFER_ROUTE_URL}/v2/TransferRoute.json?${params.join("&")}`;
    if(!window.jqXHR) { // まだリクエストが走っていない場合のみ実行
      window.jqXHR = window.$.ajax({
        url: url,
        dataType: 'jsonp',
        jsonpCallback: 'searchRouteCallback',
        success: function(transferData) {
          console.log("電車データ:", transferData);
          let {routeList, reverseGeocoder, directRoute:{walk}} = transferData;
          let processedData = {}

          // 発着の住所を取り出し
          let departureAddress = reverseGeocoder.departure.full.address;
          let arrivalAddress = reverseGeocoder.arrival.full.address;

          let maxRouteCount = 3;
          let walkRouteMinTime = 10000;

          // warkLinks が存在する場合は徒歩ルートもあり。なければ5km以上である
          let warkLinks = walk.links;
          if(warkLinks && warkLinks.link){
            processedData.walkRoute = processWalkRoute(departureAddress, arrivalAddress, walk);
            let {hrs, mns} = processedData.walkRoute.duration; // TODO: 発着が近すぎるとこれすらないので対策を考える
            walkRouteMinTime = (60 * hrs) + mns;
          }

          // routeList は [候補1, 候補2, 候補3] となっている
          processedData.routeList = processRouteList(departureAddress, arrivalAddress, routeList, maxRouteCount)
          let [minRouteTime] = processedData.routeList
            .map(({duration})=>(duration.hrs * 60) + duration.mns)
            .sort(); // ソートして先頭の値を取ることで最短の時間を取得
          
          // 徒歩ルートと乗換ルートの所要時間を比較して短い方を採用する
          if(walkRouteMinTime <= minRouteTime) {
            processedData.routeList = processedData.routeList.slice(0, maxRouteCount - 1)
          } else {
            delete processedData.walkRoute // 徒歩ルートは不要なので削除
          }

          let data = processedData;
          let currentRouteIdx = data.walkRoute? "walk" : 0;
          let geojson = makeGeoJSON(processedData, currentRouteIdx);

          if(isTablet){
            setIsSmp(true);
          }

          // 結果をURLパラメータに反映
          setNaviURLParam()
          setNaviSearch({ ...naviSearch, transitResult:geojson, transitResultData:data, currentRouteIdx});
          setResultError("");

          setTimeout(()=>{
            window.$(".navi-result-component").scrollTop(0); // 結果のスクロール位置をTOPに戻す
          }, SCROLL_DELAY_TIME);

        },
        error: function(xhr, status, error) {
          console.error("ルート検索エラー:", error);
          setResultError("transitAPIError");
        }
      }).always(function() {
        window.jqXHR = null;
      });
    }
  }

  /*****
  * リスト表示関連
  *****/

  // 乗り換えルートのタブ
  const renderRouteTabs = (currentRouteIdx, data) => {
    let routeViews = [];
    let offset = 1;
    let isList = currentRouteIdx === "list";

    if(data.walkRoute){
      offset++;
      routeViews.push({
        idx: 1,
        isWalk: true,
        isCurrent: currentRouteIdx === "walk",
        dataId: "walk"
      });
    }

    data.routeList.forEach(({isFast, isCheap, isEasy}, idx)=>{
      routeViews.push({
        idx: idx + offset,
        isFast,
        isCheap,
        isEasy,
        isCurrent: currentRouteIdx === idx,
        dataId: idx
      })
    });

    if(routeViews.length === 0){
      // なにもないときは空を返す
      return <></>;
    }

    return (
      <div className="navi-list">
        <ul>
          <li className={`navi-route-list-tab${isList? " navi-list-on": ""}`} data-id="list" onClick={changeRouteTabs}>
            <span className="navi-list-text">一覧</span>
          </li>
          {routeViews.map(({idx, isWalk, isFast, isCheap, isEasy, isCurrent, dataId})=>{
            return (
              <li className={`navi-route-list-tab${isCurrent? " navi-list-on": ""}`} data-id={dataId} onClick={changeRouteTabs}>
                <span class="navi-list-text">経路{idx}</span>
                {isFast? <span className="navi-list-fast"></span>: ""}
                {isCheap? <span className="navi-list-cheap"></span>: ""}
                {isEasy? <span className="navi-list-easy"></span>: ""}
                {isWalk? <span className="navi-list-walk"></span>: ""}
              </li>
            );
          })}
        </ul>
      </div>
    );


  }

  /*
   * 移動時間と料金の総合表示
  */
  const renderRouteInfo = (route, idx, offset) => {
    if(!route) return "";
    let {fare, isFast, isCheap, isEasy, transfers, departure, arrival} = route;
    fare = _toThousandSeparator(route.fare);
    let startHour = _pad(departure.time.hour);
    let startMin = _pad(departure.time.min);
    let endHour = _pad(arrival.time.hour);
    let endMin = _pad(arrival.time.min);
    let isWalk = false;

    if(idx === "walk"){
      isWalk = true;
      idx = 1;
    }else{
      idx += offset;
    }

    return (
      <div className="navi-info">
        <div className="navi-info-wrap">
          <div className="navi-info-left">
            <div className="navi-info-num">経路{idx}</div>
            <div className="navi-info-icon">
              {isFast? <span class="navi-list-fast"></span>: ""}
              {isCheap? <span class="navi-list-cheap"></span>: ""}
              {isEasy? <span class="navi-list-easy"></span>: ""}
              {isWalk? <span class="navi-list-walk"></span>: ""}
            </div>
          </div>
          <div className="navi-info-right">
            <div className="navi-info-time">
              {!isWalk? `${startHour}:${startMin} ⇒ ${endHour}:${endMin}`: ""}
              {!isWalk
                ? <div className="navi-info-other">運賃：{fare}円　乗換：{transfers}回</div>
                : <p>徒歩のみ</p>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  
  const renderRouteList = (data, currentRouteIdx) => {
    let routeViews = [];
    let offset = 1;

    if(data.walkRoute){
      offset++;
      routeViews.push({
        idx: 1,
        isWalk: true,
        isCurrent: currentRouteIdx === "walk",
        dataId: "walk",
        duration: hrsMnsToJiFunStr(data.walkRoute.duration)
      });
    }

    data.routeList.forEach(({isFast, isCheap, isEasy, fare, transfers, duration, departure, arrival}, idx)=>{
      routeViews.push({
        idx: idx + offset,
        isFast,
        isCheap,
        isEasy,
        isCurrent: currentRouteIdx === idx,
        dataId: idx,
        fare: _toThousandSeparator(fare),
        transfers: transfers,
        duration: hrsMnsToJiFunStr(duration),
        startHour: _pad(departure.time.hour),
        startMin: _pad(departure.time.min),
        endHour: _pad(arrival.time.hour),
        endMin: _pad(arrival.time.min)
      })
    });

    return (
      <ul class="navi-info-list">
        {routeViews.map(({idx, isWalk, isFast, isCheap, isEasy, isCurrent,
          duration, fare, transfers, dataId, startHour, startMin, endHour, endMin})=>{
          return (
          <li data-id={dataId} onClick={changeRouteTabs} style={isCurrent? {"background-color": `#d8e3f4`}: {}}>
            <div className="navi-info-wrap">
              <div className="navi-info-left">
                <div className="navi-info-num">経路{idx}</div>
                <div className="navi-info-icon">
                  {isFast? <span className="navi-list-fast"></span>: ""}
                  {isCheap? <span className="navi-list-cheap"></span>: ""}
                  {isEasy? <span className="navi-list-easy"></span>: ""}
                  {isWalk? <span className="navi-list-walk"></span>: ""}
                </div>
              </div>
              <div class="navi-info-right">
                <div class="navi-info-time">
                  {!isWalk
                    ? <>
                      {startHour}:{startMin} ⇒ {endHour}:{endMin}
                      <span class="navi-info-sub">（{duration}）</span>
                      <div class="navi-info-other">運賃：{fare}円　乗換：{transfers}回</div>
                    </>
                    : <>
                      {duration}
                      <p>徒歩のみ</p>
                    </>
                  }
                </div>
              </div>
            </div>
          </li>)
        })}
      </ul>
    )
  }

  const renderSpotStart = (route, naviStart)=>{
    let {departure: {time:{hour, min}, routeType, distance, duration}} = route;
    let {lat:startLat, lon: startLon, name} = naviStart;
    let startHour = _pad(hour);
    let startMin = _pad(min);
    let type = routeType.toLowerCase()
    let lineName = "";
    let address = name;
    
    if(routeType === TYPE.CAR){
      lineName = "車";
    } else if(TYPE.WALK){
      lineName = "徒歩";
    }

    return (
      <>
        <div className="navi-spot navi-spot-start" data-lat={startLat} data-lon={startLon}>
          <p className="navi-spot-time">{startHour}:{startMin}発</p>
          <p className="navi-spot-icon"><span className="navi-icon-inner">発</span></p>
          <p className="navi-spot-name">
            <a onClick={(e)=> moveCenter(e, startLat, startLon)} href="#">{address}</a>
          </p>
        </div>
        <div className={`navi-line navi-line-${type}`}  onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon">
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">{lineName}（{distance}m）</p>
        </div>
      </>
    );   
  }

  const renderSpotEnd = (route, naviEnd)=>{
    let {arrival:{time:{hour, min}, routeType, distance, duration}} = route;
    let {lat:endLat, lon:endLon, name} = naviEnd;
    let endHour = _pad(hour);
    let endMin = _pad(min);
    let type = routeType.toLowerCase()
    let lineName = "";
    let address = name;
        
    if(routeType === TYPE.CAR){
      lineName = "車";
    } else if(TYPE.WALK){
      lineName = "徒歩";
    }

    return (
      <>
        <div className={`navi-line navi-line-${type}`} onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon">
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">{lineName}（{distance}m）</p>
        </div>
        <div className="navi-spot navi-spot-end" data-lat={endLat} data-lon={endLon}>
            <p className="navi-spot-time">{endHour}:{endMin}着</p>
            <p className="navi-spot-icon"><span className="navi-icon-inner">着</span></p>
            <p className="navi-spot-name">
              <a onClick={(e)=> moveCenter(e, endLat, endLon)} href="#">{address}</a>
            </p>
        </div>
      </>
    );   
  }

  const renderStationFrom = (line, isStart, prevLineNameForColorization, arrivalInfo)=>{
    let {isChokutsuu, stationFrom:{time:{hour, min}, stationName, coordinate:{latitude, longitude}}} = line;
    let departureHours = _pad(hour);
    let departureMinutes =  _pad(min);
    
    let name =  stationName;
    let fare = _toThousandSeparator(line.fare);
    let hasFare = line.fare && line.fare !== '';
    let {x: lon, y:lat} = MapionDatumUtil.tky.wgs({y: latitude, x: longitude});
    let lineNameForColorization = null;
    let endHour = null;
    let endMin = null;

    if(isChokutsuu && prevLineNameForColorization){
      lineNameForColorization = prevLineNameForColorization;
    }

    if(arrivalInfo){
      endHour = _pad(+arrivalInfo.hour);
      endMin = _pad(+arrivalInfo.min);
    }

    // 直通の場合のテンプレート
    if(isChokutsuu){
      return (
        <div className="navi-spot navi-spot-direct">
          <p className="navi-spot-time">【直通】</p>
          <p className="navi-spot-icon" data-line-name={lineNameForColorization} style={{"border-color": `#ccc`}}>
            <span className="navi-icon-inner"></span>
          </p>
          <p className="navi-spot-name">{{name}}</p>
          (hasFare
            ? <p className="navi-spot-price">{fare}円</p>
            : ""
          )
        </div>
      );
    } else {
      return (
        <div className={`navi-spot${isStart? " navi-spot-start": ""}`} data-lat={lat} data-lon={lon}>
          <p className="navi-spot-time">
            {endHour && endMin
              ? <span>{endHour}:{endMin}着<br /></span>
              : ""
            }
            {departureHours}:{departureMinutes}発
          </p>
          <p className="navi-spot-icon">
            <span className="navi-icon-inner">
              {isStart? "発": ""}
            </span>
          </p>
          <p className="navi-spot-name">
            <a onClick={(e)=> moveCenter(e, lat, lon)} href="#">{name}</a></p>
            {hasFare
              ? <p className="navi-spot-price">{fare}円</p>
              : ""
            }
        </div>
      )
    }
  }

  const timeToMin = (time) => {
    return (time.hour * 60) + time.min;
  }

  const hrsMnsToJiFunStr = ({hrs, mns}) => {
    if(hrs > 0){
      return `${hrs}時間${mns}分`;
    }else{
      return `${mns}分`
    }
  }

  const extractDuration = (startTime, endTime) =>{
    startTime.hour = +startTime.hour;
    startTime.min = +startTime.min;
    endTime.hour = +endTime.hour;
    endTime.min = +endTime.min;

    // 零時を回った場合、24時間シフトしないといけない
    // 0時→24時
    // 1時→25時
    // 等々
    if (startTime.hour > endTime.hour) {
      endTime.hour += 24;
    }
    let startMins = timeToMin(startTime);
    let endMins = timeToMin(endTime);
    return endMins - startMins;
  }

  /*
   * ポイント間のラインのリスト表示
  */
  const renderLine = (line, lineNameForColorization)=>{
    let {kind, lineName, stationFrom, stationTo, boundFor, distance} = line;
    let duration = extractDuration(stationFrom.time, stationTo.time);
    let hasBoundFor = typeof boundFor === "string";

    if(extractType(line) === TYPE.WALK){
      return (
        <div className="navi-line navi-line-walk" onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon">
              <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">徒歩{distance? `${distance}m`: ""}</p>
        </div>
      );
    } else if(extractType(line) === TYPE.TRAIN) {
      return (
        <div className="navi-line navi-line-train" onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon" data-line-name={lineNameForColorization} style={{"border-color": `#ccc`}}>
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">
            {lineName}
            {hasBoundFor
              ? ` ${kind? kind: ""}（${boundFor}行）`
              : ""
            }
          </p>
        </div>
      );
    } else if(extractType(line) === TYPE.SHINKANSEN) {
      return (
        <div className="navi-line navi-line-shin" onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon" data-line-name={lineNameForColorization} style={{"border-color": `#ccc`}}>
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">
            {lineName}
            {hasBoundFor
              ?`（${boundFor}行）`
              : ""
            }
          </p>
        </div>
      )
    } else if(extractType(line) === TYPE.PLANE) {
      return (
        <div className="navi-line navi-line-plane" onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon">
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">
            {lineName}
            {hasBoundFor
              ?`（${boundFor}行）`
              : ""
            }
          </p>
        </div>
      )
    } else if(extractType(line) === TYPE.BUS) {
      return (
        <div className="navi-line navi-line-bus" onClick={fitPointToPoint}>
          <p className="navi-line-time">{duration}分</p>
          <div className="navi-line-icon">
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">
            {lineName}
            {hasBoundFor
              ?`（${boundFor}行）`
              : ""
            }
          </p>
        </div>
      )
    } else {
      // 'no tmpl for'
      return (
        <div>
          <div>{lineName}（{kind}）</div>
          {/* 本来は発着の時間を入れるのだが、まずありえないので一旦コメントアウト */}
          {/* <div>{stationFromHour}:{stationFromMin}発&nbsp;{stationFromName}</div>
          <div>{stationToHour}:{stationToMin}着&nbsp;{stationToName}</div> */}
        </div>
      );
    }
  }

  const renderStationTo = (line, isEnd) => {
    let {stationTo:{time:{hour, min}, stationName, coordinate:{latitude, longitude}}} = line;
    let {x: lon, y:lat} = MapionDatumUtil.tky.wgs({y: latitude, x: longitude});

    return (
      <div className={`navi-spot ${isEnd? " navi-spot-end": ""}`} data-lat={lat} data-lon={lon}>
        <p className="navi-spot-time">{_pad(hour)}:{_pad(min)}着</p>
        <p className="navi-spot-icon">
          <span className="navi-icon-inner">{isEnd? "着": ""}</span>
        </p>
        <p className="navi-spot-name">
          <a onClick={(e)=> moveCenter(e, lat, lon)} href="#">{stationName}</a>
        </p>
      </div>
    );
  }

  const renderWalkList = (route, naviStart, naviEnd) => {
    if(!route) return "";
    let {distance, duration: {hrs, mns}} = route;
    let lineName = null;
    if(route.departure.routeType === TYPE.CAR){
      lineName = "車";
    } else if(route.departure.routeType === TYPE.WALK){
      lineName = "徒歩";
    }

    var {name: startName, lat:startLat, lon: startLon} = naviStart;
    var {name: endName, lat:endLat, lon:endLon} = naviEnd;


    return (
      <div className="navi-route">
        <div className="navi-spot navi-spot-start" data-lat={startLat} data-lon={startLon}>
          <p className="navi-spot-icon"><span className="navi-icon-inner">発</span></p>
          <p onClick={(e)=> moveCenter(e, startLat, startLon)} className="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat={startLat} data-lon={startLon}>{startName}</a></p>
        </div>
        <div className="navi-line navi-line-walk">
          <p className="navi-line-time">{(hrs * 60) + mns}分</p>
          <div className="navi-line-icon">
            <span className="navi-icon-inner"></span>
          </div>
          <p className="navi-line-name">徒歩{lineName}（{distance}m）</p>
        </div>
        <div className="navi-spot navi-spot-end" data-lat={endLat} data-lon={endLon}>
          <p className="navi-spot-icon"><span className="navi-icon-inner">着</span></p>
          <p onClick={(e)=> moveCenter(e, endLat, endLon)} className="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat={endLat} data-lon={endLon}>{endName}</a></p>
        </div>
      </div>
    )

  }


  // 日本の鉄道ラインカラーに合わせた区間の色をレンダリングする
  const renderColorizablelines = (lines = []) => {
    let colorizableLineNames = extractColorizableLineNames(lines);
    if(isArray(colorizableLineNames)){
      lineColorDict.getColorsFor(colorizableLineNames, (err, tblOfLineNamesToColors)=>{
        if(err) return; // void
        for (let lineName in tblOfLineNamesToColors) {
          let color = tblOfLineNamesToColors[lineName];
          window.$(`[data-line-name=${lineName}]`).css('border-color', color); // void
        }
      });
    }
  }

  //「路線色有り」路線名を抽出する
  const extractColorizableLineNames = (lines) => {
    let setOfLineNames = {};
    lines.forEach(({railKind, lineName})=>{
      if(lineColorDict.isColorizableRailKind(railKind)){
        setOfLineNames[lineColorDict.fixLineNameForColorSearch(lineName)] = true;
      }
    });
    return Object.keys(setOfLineNames);
  }

  // !!!! ここからがtransitResultのメイン処理開始 !!!!
  
  if(naviSearch.reSearchFlag){ // 再検索フラグがある場合(※ルート検索ボタンなどが押下されたら場合にフラグが立つ)
    // 検索結果を削除して次のレンダー(再帰)で再検索する
    setNaviSearch({ ...naviSearch, transitResult: null, transitResultData: null, resultRendered: false, reSearchFlag: false });
  }

  // データがないときは検索を実行する
  if(!naviSearch.transitResult) {
    execSearch();
    return (
      <div className="navi-result-component">
        読み込み中
      </div>
    );
  } else if(resultError === "transitAPIError"){
    return (
      <div className="navi-result-component">
        乗り換え徒歩ルートの検索が失敗しました。時間を置いてから再度検索してください。
      </div>
    );
  }

  let lines = [];
  let routeTabs = ""
  let routeInfo = "";
  let lineLists = [];
  let {transitResultData, currentRouteIdx} = naviSearch;
  let showingRouteList = currentRouteIdx === "list";
  let isError = false;
  if(transitResultData){
    let data = transitResultData;
    let route = currentRouteIdx === "walk"
            ? data.walkRoute
            : data.routeList[currentRouteIdx];

    // 合計距離や時間の処理
    let offset = data.walkRoute? 2 : 1;
    routeInfo = renderRouteInfo(route, currentRouteIdx, offset);

    // タブの表示を生成する
    routeTabs = renderRouteTabs((showingRouteList? "list": currentRouteIdx), transitResultData);

    if(showingRouteList){
      // リスト一覧の表示
      lineLists.push(renderRouteList(data, currentRouteIdx));
    }else{
      // 乗り換えルートの表示
      lines = route? route.lines: null;
      // if(lines && typeof lines.length !== "number"){ // よくわからんが徒歩ルートであることの判定 ※本当によくわからないので一旦walkかどうかで判定する
      if(currentRouteIdx === "walk"){
        if(route && isArray(route.links)){
          lineLists.push(renderWalkList(route, naviStart, naviEnd));
        }
      } else if(!route){
        // 発着が存在しない場合はエラー文言を表示する
        isError = true;
      } else {
        // 発のリスト表示
        if(route.departure.hasRoute){
          lineLists.push(renderSpotStart(route, naviStart));
        }
        // 到着情報を次のループイテレーションで使う為、
        // 一時保存する
        let arrivalInfo = null;
        
        // 直前の色引き可能路線名の一時保存場所
        let prevLineNameForColorization = null

        lines.forEach((line, idx)=> {
          let isStart = idx === 0 && !route.departure.hasRoute; // 発情報がなくて先頭の場合は1番目を発扱いにする
          lineLists.push(renderStationFrom(line, isStart, prevLineNameForColorization, arrivalInfo));

          let {stationTo:{time}, lineName, railKind} = line;

          arrivalInfo = {
            hour: time.hour,
            min: time.min
          }
          // 色を変える路線か判定して、名称をfixする
          if(lineColorDict.isColorizableRailKind(railKind)) {
            prevLineNameForColorization = lineColorDict.fixLineNameForColorSearch(lineName);
          } else {
            prevLineNameForColorization = null;
          }

          // 電車などの乗り換えルートのリストを作成
          lineLists.push(renderLine(line, prevLineNameForColorization));

          // 最後の区間はstationToも描画する
          if(idx === lines.length -1){
            let isEnd = !route.arrival.hasRoute;
            lineLists.push(renderStationTo(line, isEnd));
          }
        });

        // 着のリスト表示
        if(route.arrival.hasRoute){
          lineLists.push(renderSpotEnd(route, naviEnd));
        }
      }
    }
  }

  // 線路の色分けを行う
  if(lines){
    renderColorizablelines(lines);
  }

  if(isError) {
    return (
      <div>ルート検索ができませんでした。<br />検索条件を変更して再度お試しください。</div>
    )
  }

  return (
    <div className="transit-result">
      {routeTabs}
      <div className="navi-info-wrapper" onClick={()=> naviToggle(true)}>
        {routeInfo}
      </div>
      <div class="navi-route">
        {lineLists}
      </div>
      <p class="navi-ekitan">Powered by 駅探</p>
    </div>
  );
};

export default TransitResult;
